import { useContext } from 'react'

import { SubmissionListFilterContext } from './Provider'

export const useSubmissionListFilter = () => useContext(SubmissionListFilterContext)

export default useSubmissionListFilter
